// styles
import styles from './step-card.module.scss'

type StepCardProps = {
	readonly stepTitle: string
} & React.HTMLAttributes<HTMLDivElement>

const StepCard = (props: StepCardProps): JSX.Element => {
	const { children, className, stepTitle, ...attr } = props

	return (
		<div
			{...attr}
			className={[styles.stepCard, className].join(' ').trim()}
		>
			<h1 className={styles.title}>
				<span>{stepTitle}</span>
			</h1>
			<div className={styles.content}>
				<div>{children}</div>
			</div>
		</div>
	)
}

export default StepCard
